"use client";

import type { ReactNode } from "react";

export interface ChartCardProps {
  title: string;
  caption?: string | null;
  children: ReactNode;
}

export function ChartCard({ title, caption, children }: ChartCardProps) {
  return (
    <div className="bg-surface border border-surface-light/10 rounded-xl p-5">
      <div className="mb-1 flex items-center gap-2">
        <h4 className="text-sm font-serif text-foreground">{title}</h4>
      </div>
      {caption && (
        <p className="text-xs text-muted-foreground mb-3 leading-relaxed">{caption}</p>
      )}
      <div className="relative">{children}</div>
    </div>
  );
}
